import React, { useState, useEffect } from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface CaracteristicasVehiculosComponentProps {
  caracteristicas: any;
}

const CaracteristicasVehiculosComponent: React.FC<
  CaracteristicasVehiculosComponentProps
> = ({ caracteristicas }) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : caracteristicas?.tecnologia?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < caracteristicas?.tecnologia?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="caracteristica-vehiculos-detail-component">
      {/* H2 - Título de la sección de tecnología */}
      <h2 className="title-tecnologia-vehiculos-detail-component">
        Tecnología que asiste tu viaje
      </h2>
      
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img src="/assets/01_Home/Icon_Left.svg" alt="Anterior" />
      </div>
      
      <div
        className="carrousel-caracteristica-vehiculos-detail-component"
        style={{
          transform:
            currentIndex === 0
              ? `translateX(${windowWidth < 768 ? "10%" : "25%"})`
              : `translateX(-${
                  windowWidth < 768
                    ? currentIndex * 70 === 70
                      ? currentIndex * 70
                      : currentIndex * 80 - 10
                    : currentIndex * 25 === 25
                    ? currentIndex * 25
                    : currentIndex * 25 === 50
                    ? currentIndex * 25 + 25
                    : currentIndex * 50 + 25 - 50
                }%)`,
        }}
      >
        {caracteristicas?.tecnologia?.map((item: any, index: any) =>
          item?.media !== null ? (
            <div
              className={`item-caracteristica-vehiculos-detail-component`}
              key={index}
            >
              <img
                src={buildCmsUrl(item?.media?.url)}

                srcSet={getSrcSet(item?.media?.url || '')}
                sizes={getSizes('600px')}
                alt={item?.title || "Imagen de tecnología del vehículo"}
              />

            </div>
          ) : null
        )}
      </div>
      
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img src="/assets/01_Home/Icon_Right.svg" alt="Siguiente" />
      </div>
      
      <div className="info-caracteristica-vehiculos-detail-component">
        {/* H3 - Título de la característica actual */}
        <h3 className="title-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia[currentIndex]?.title}
        </h3>
        
        {/* H4 - Descripción de la característica actual */}
        <h4 className="descripcion-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia[currentIndex]?.description}
        </h4>
        
        <div className="index-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia?.map((item: any, index: number) => (
            <div
              className={`${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
              key={index}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaracteristicasVehiculosComponent;